'use client';

const isCMSDashboard = () => {
  return (window as any)?.location?.pathname?.split('/').at(1) == 'cms';
};
export default isCMSDashboard;
